import axios from '@/http/axios'
import {createCancelTokenHandler, makeQuery} from '../axios/utils'

const cancelTokenHandlerObject = {
  getUsers: createCancelTokenHandler('getUsers'),
  getUserTrash: createCancelTokenHandler('getUserTrash'),
  getUserTasks: createCancelTokenHandler('getUserTasks'),
  getUserTickets: createCancelTokenHandler('getUserTickets')
}

export function getUsers (page = 1, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)
  //simple filters ['name=ali', 'createdAt=1399/03/05']
  //simple sorts ['order[0]=fullName,desc']

  if (queries.length > 0) queries = `?${  queries.join('&')}`
  return axios({
    url: `v1/users${queries}`,
    method: 'get',
    cancelToken: cancelTokenHandlerObject['getUsers'].handleRequestCancellation().token
  })
}

export function getUserTrash (page = 1, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `&${  queries.join('&')}`
  return axios({
    url: `v1/users?trashed=true${queries}`,
    method: 'get',
    cancelToken: cancelTokenHandlerObject['getUserTrash'].handleRequestCancellation().token
  })
}

export function getUser (id, loading) {
  return axios({
    url: `v1/users/${id}`,
    method: 'get',
    loading
  })
}

export function insertUser (data) {
  return axios({
    url: 'v1/users',
    data,
    method: 'post'
  })
}

export function editUser (id, payment) {
  return axios.patch(`v1/users/${id}`, payment)
}

export function deleteUser (id, force = false) {
  return axios({
    url: `v1/users/${id}${force ? '/force' : ''}`,
    method: 'delete'
  })
}

export function restoreUser (id) {
  return axios({
    url: `v1/users/${id}/restore`,
    method: 'put'
  })
}

export function getUserTasks (id, page = 1, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)
  //simple filters ['name=ali', 'createdAt=1399/03/05']
  //simple sorts ['order[0]=fullName,desc']

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/users/${id}/tasks${queries}`,
    method: 'get',
    cancelToken: cancelTokenHandlerObject['getUserTasks'].handleRequestCancellation().token
  })
}

export function getUserTickets (id, page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${queries.join('&')}`

  return axios({
    url: `v1/users/${id}/tickets${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getUserTickets'].handleRequestCancellation().token
  })
}
